import React, { useState, useEffect } from 'react';
import DataTable from '../DataTable';
import { getPackages } from '../../utils/api';

export default function WarehouseItemsSection() {
  const [packageData, setPackageData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [messageType, setMessageType] = useState('error'); // 'error', 'info', 'warning'
  const [selectedRow, setSelectedRow] = useState(null);
  const [selectedPosition, setSelectedPosition] = useState(null);
  const [showDetailCard, setShowDetailCard] = useState(false);
  const [latestPackage, setLatestPackage] = useState(null);
  const [documentsInfo, setDocumentsInfo] = useState([]);

  // Завантажуємо пакети при монтуванні компонента
  useEffect(() => {
    fetchPackageData();
  }, []);
  // Замінюємо кириличні ключі на латиницю для уникнення проблем з кодуванням
  const fetchPackageData = async () => {    try {
      setLoading(true);
      setError('');
      setMessageType('error');

      const response = await getPackages();
      console.log('Завантажені пакети:', response);

      if (Array.isArray(response.packages) && response.packages.length > 0) {
        // Фільтруємо пакети з операцією "PosBal"
        const posBalPackages = response.packages.filter(pkg => pkg.ВидОперации === 'PosBal' && pkg.Документы && pkg.Документы.length > 0);
        
        if (posBalPackages.length > 0) {
          // Беремо найновіший пакет PosBal
          const latest = posBalPackages[0]; // вже відсортовані по даті
          setLatestPackage(latest);
          const { positions, documents } = extractAndGroupPositions(latest);
          setPackageData(positions);
          setDocumentsInfo(documents);
        } else {
          setPackageData([]);
          setError('Немає доступних пакетів з операцією PosBal.');
          setMessageType('info');
        }
      } else {
        setPackageData([]);
        setError('Дані пакетів поки не завантажені.');
        setMessageType('info');
      }
    } catch (err) {
      console.error('Помилка завантаження пакетів:', err);
      setError('Помилка завантаження даних: ' + (err.message || 'Невідома помилка'));
      setMessageType('error');
      setPackageData([]);
    } finally {
      setLoading(false);
    }
  };
  const extractAndGroupPositions = (packageData) => {    if (!Array.isArray(packageData.Документы)) {
      return { positions: [], documents: [] };
    }
    
    const positionGroups = new Map();
    const documentsInfo = [];

    packageData.Документы.forEach(document => {
      // Збираємо інформацію про документ
      const positionsCount = document.Позиции ? document.Позиции.length : 0;
      documentsInfo.push({
        вид: document.ДокументВид || 'Не вказано',
        номер: document.ДокументНомер || 'Не вказано',
        дата: document.ДокументДата,
        позиций: positionsCount
      });

      if (Array.isArray(document.Позиции)) {
        document.Позиции.forEach(position => {
          const key = position.Код + '|' + (position.Наименование || '');

          if (positionGroups.has(key)) {
            const existing = positionGroups.get(key);
            existing.КоличествоФакт += position.КоличествоФакт || 0;
            existing.КоличествоПлан += position.КоличествоПлан || 0;
            existing.КоличествоРезерв += position.КоличествоРезерв || 0;
            existing.documentCount += 1;
          } else {
            positionGroups.set(key, {
              Код: position.Код,
              Наименование: position.Наименование,
              Склад: position.Склад,
              КоличествоПлан: position.КоличествоПлан,
              КоличествоФакт: position.КоличествоФакт,
              КоличествоРезерв: position.КоличествоРезерв,
              documentCount: 1,
              documentNumber: document.ДокументНомер,
              documentDate: document.ДокументДата
            });
          }
        });
      }
    });

    return {
      positions: Array.from(positionGroups.values()),
      documents: documentsInfo
    };
  };

  const handleRowClick = (position, index) => {
    setSelectedRow(index);
    setSelectedPosition(position);
    setShowDetailCard(true);
  };

  const closeDetailCard = () => {
    setShowDetailCard(false);
    setSelectedPosition(null);
    setSelectedRow(null);
  };

  const columns = [
    { key: 'Код', label: 'Артикул', width: '120px' },
    { key: 'Наименование', label: 'Наименование', width: 'auto' },
    { key: 'Склад', label: 'Склад', width: '150px' },
    { key: 'КоличествоПлан', label: 'План', width: '80px', align: 'right' },
    { key: 'КоличествоФакт', label: 'Факт', width: '80px', align: 'right' },
    { key: 'КоличествоРезерв', label: 'Резерв', width: '80px', align: 'right' }
  ];

  if (loading) {
    return (
      <div style={{
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '16px',
        color: '#666'
      }}>
        Завантаження позицій...
      </div>
    );
  }
  if (error) {
    const getMessageStyle = () => {
      switch (messageType) {
        case 'info':
          return {
            color: '#1976d2',
            icon: '📋',
            title: 'Інформація'
          };
        case 'warning':
          return {
            color: '#f57c00',
            icon: '⚠️',
            title: 'Попередження'
          };
        case 'error':
        default:
          return {
            color: '#d32f2f',
            icon: '❌',
            title: 'Помилка завантаження'
          };
      }
    };

    const messageStyle = getMessageStyle();

    return (
      <div style={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px',
        color: messageStyle.color
      }}>
        <div style={{ fontSize: '18px', marginBottom: '10px' }}>
          {messageStyle.icon} {messageStyle.title}
        </div>
        <div style={{ fontSize: '14px', textAlign: 'center' }}>{error}</div>
        <button
          onClick={fetchPackageData}
          style={{
            marginTop: '15px',
            padding: '8px 16px',
            background: messageType === 'info' ? '#1976d2' : messageType === 'warning' ? '#f57c00' : '#1976d2',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer'
          }}
        >
          {messageType === 'error' ? 'Повторити спробу' : 'Оновити'}
        </button>
      </div>
    );
  }

  return (
    <div style={{
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      minHeight: 0,
      padding: window.innerWidth < 768 ? '8px 0' : '16px',
      boxSizing: 'border-box'
    }}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: window.innerWidth < 768 ? '8px' : '16px',
          margin: window.innerWidth < 768 ? '0 8px 8px 8px' : '0 0 16px 0',
          padding: window.innerWidth < 768 ? '8px' : '12px',
          background: 'linear-gradient(135deg, #e3f2fd 0%, #2196f3 100%)',
          border: window.innerWidth < 768 ? 'none' : '1px solid #2196f3',          borderRadius: window.innerWidth < 768 ? '0' : '8px',
          boxShadow: window.innerWidth < 768 ? 'none' : '0 2px 6px rgba(33, 150, 243, 0.2)',
          flexShrink: 0
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <span style={{ fontSize: '32px', marginRight: '12px' }}>🏪</span>
          <div>
            <h2
              style={{
                margin: 0,
                fontSize: '20px',
                fontWeight: '600',
                color: '#1565c0'
              }}
            >
              {latestPackage ? `Пакет: ${latestPackage.ИдентификаторПакета}` : 'Warehouse Items'}
            </h2>
            <div style={{
              fontSize: '14px',
              color: '#1976d2',
              fontWeight: '500',
              marginTop: '2px'
            }}>
              {documentsInfo.length > 0 ? (
                <div>
                  {documentsInfo.map((doc, index) => (
                    <div key={index} style={{ marginBottom: '2px' }}>
                      {doc.вид} № {doc.номер} від {doc.дата ? new Date(doc.дата).toLocaleDateString('uk-UA') : 'Не вказана'} • Всього позицій: {doc.позиций}
                    </div>
                  ))}
                </div>
              ) : (
                'Товари складу • Warehouse Items'
              )}
            </div>
          </div>
        </div>
      </div>

      <div
        style={{
          flex: 1,
          minHeight: 0,
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        <DataTable
          data={packageData}
          columns={columns}
          onRowClick={handleRowClick}
          selectedRowIndex={selectedRow}
          options={{
            height: '100%',
            maxHeight: '100%',
            bordered: true,
            filterable: true,
            sortable: true,
            showRowNumbers: true
          }}
        />
      </div>

      {/* Детальная карточка */}
      {showDetailCard && selectedPosition && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0,0,0,0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1000
        }}>
          <div style={{
            background: 'white',
            padding: '20px',
            borderRadius: '8px',
            maxWidth: '500px',
            width: '90%',
            maxHeight: '80%',
            overflow: 'auto',
            boxShadow: '0 4px 20px rgba(0,0,0,0.3)'
          }}>
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '15px',
              borderBottom: '1px solid #eee',
              paddingBottom: '10px'
            }}>
              <h3 style={{ margin: 0, color: '#333' }}>Деталі позиції</h3>
              <button
                onClick={closeDetailCard}
                style={{
                  background: 'none',
                  border: 'none',
                  fontSize: '20px',
                  cursor: 'pointer',
                  color: '#666'
                }}
              >
                ×
              </button>
            </div>

            <div style={{ fontSize: '14px' }}>
              <div style={{ marginBottom: '10px' }}>
                <strong>Артикул:</strong> {selectedPosition.Код}
              </div>
              <div style={{ marginBottom: '10px' }}>
                <strong>Найменування:</strong> {selectedPosition.Наименование}
              </div>
              <div style={{ marginBottom: '10px' }}>
                <strong>Штрих-код:</strong> {selectedPosition.Штрихкод || 'Не вказано'}
              </div>
              <div style={{ marginBottom: '10px' }}>
                <strong>Кількість План:</strong> {selectedPosition.КоличествоПлан || 0}
              </div>
              <div style={{ marginBottom: '10px' }}>
                <strong>Кількість Факт:</strong> {selectedPosition.КоличествоФакт || 0}
              </div>
              <div style={{ marginBottom: '10px' }}>
                <strong>Кількість Резерв:</strong> {selectedPosition.КоличествоРезерв || 0}
              </div>
              {selectedPosition.documentNumber && (
                <div style={{ marginBottom: '10px' }}>
                  <strong>Документ:</strong> {selectedPosition.documentNumber}
                </div>
              )}
              {selectedPosition.documentDate && (
                <div style={{ marginBottom: '10px' }}>
                  <strong>Дата документа:</strong> {new Date(selectedPosition.documentDate).toLocaleDateString('uk-UA')}
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
